
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.946 1.736a.463.463 0 00-.458-.403.463.463 0 00-.461.466v.514H5.979v-.514l-.004-.063a.463.463 0 00-.458-.403.463.463 0 00-.461.466v.525C3.164 2.454 2 3.68 2 5.657v5.613c0 2.122 1.306 3.397 3.397 3.397h5.205c2.095 0 3.398-1.254 3.398-3.35v-5.66c.006-1.978-1.155-3.203-3.05-3.333V1.8l-.004-.063zm-.92 1.507v.596l.005.064c.03.227.224.402.457.402a.463.463 0 00.462-.466v-.582c1.379.115 2.131.945 2.127 2.399v.27H2.923v-.269c0-1.453.756-2.285 2.133-2.4v.582l.004.064c.03.227.224.402.457.402a.463.463 0 00.462-.466v-.596h4.048zM2.924 6.856v4.414c0 1.601.886 2.467 2.474 2.467h5.205c1.594 0 2.475-.848 2.475-2.42V6.855H2.923zm8.278 1.956a.463.463 0 00-.462-.465l-.068.005a.465.465 0 00.068.926l.063-.005a.464.464 0 00.399-.46zm-3.192-.465c.254 0 .461.209.461.465 0 .236-.174.43-.399.461l-.062.005a.465.465 0 01-.069-.926l.069-.005zm-2.275.465a.463.463 0 00-.462-.465l-.068.005a.464.464 0 00-.4.46c0 .257.207.466.462.466l.069-.005a.464.464 0 00.399-.46zm5.005 1.946c.255 0 .462.208.462.465 0 .235-.174.43-.4.46l-.062.005a.465.465 0 01-.068-.926l.068-.005zm-2.269.465a.463.463 0 00-.461-.466l-.069.005a.465.465 0 00.068.926l.063-.004a.464.464 0 00.4-.461zm-3.198-.466c.255 0 .462.209.462.466 0 .235-.174.43-.4.46l-.068.005a.463.463 0 01-.461-.465c0-.236.173-.43.399-.461l.068-.005z","fill":"#666"}})])
          )
        }
      }
    